import { selfAxios } from "../../../../../../axios/selfAxios.js";
async function reqGetCurrentUser() {
  const {
    data: { data }
  } = await selfAxios.get("/ucenterapi/uc/internal/common/getCurrentUser", { params: { platformType: "any" }, _cache: true });
  return data;
}
export { reqGetCurrentUser };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/ucenterapi/uc/internal/common/getCurrentUser/get.js